<rb-loading-spinner *ngIf="dataLoading" class="spinner"></rb-loading-spinner>
<div class="row ms-0 me-0" *ngIf="errorMessage && !dataLoading">
    <rb-callout type="warning">
        No data for "Time Spent in High Temperature" chart.
    </rb-callout>
</div>
<div id="time-spent-extreme-temp-high-ef-chart"></div>
<div class="p-2" *ngIf="!dataLoading && !errorMessage">
    <div class="shaded-container ">
        Percentage of vehicles that spent a certain amount (indicated by x-axis) in very hot temperature conditions along with the corresponding value(s) of the selected vehicle(s). The higher the amount of time spent in extreme conditions, the more the battery might be affected negatively. If too high temperatures are encountered, this might also indicate problems in the cooling system.
    </div>
</div>